import React, { PropsWithChildren } from 'react'
import { Button } from '../../../components/button/button'
import { CTA as CTABase } from '../../../components/cta/cta'
import { isNotNull } from '../../../utils/nonNull'
import { ProducDetailsFullScreenCtaFragment } from '@gql'

export type FullScreenCtaProps = {
  data: ProducDetailsFullScreenCtaFragment[]
}

export const FullScreenCta: React.FC<PropsWithChildren<FullScreenCtaProps>> = ({ data }) => {
  if (!data[0] || data[0].__typename !== 'fullScreenCta_BlockType') {
    return null
  }

  const { background, text, ctaLink } = data[0]

  return background?.[0]?.url ? (
    <CTABase imageURL={background[0].url}>
      <CTABase content>
        <CTABase heading>
          {text}
        </CTABase>
        <CTABase buttons>
          { ctaLink && ctaLink.__typename === 'linkField_Link' && isNotNull(ctaLink.url) && isNotNull(ctaLink.customText) && (
            <Button cta href={ctaLink.url || '#'}>{ctaLink.customText}</Button>
          )}
        </CTABase>
      </CTABase>
    </CTABase>
  ) : null
}
